import { useContext, useEffect, useState } from "react";
import ResponsivContent from "../ResponsivContent";
import {
  MobileStepper,
  Step,
  StepButton,
  Stepper,
  Typography,
  useMediaQuery,
} from "@mui/material";
import styles from "./styles.module.css";
import StepIconCustom from "../StepIconCustom";
import CheckIcon from "@mui/icons-material/Check";
import DadosTitular from "./DadosTitular";
import ResponsavelEmpresa from "./ResponsavelEmpresa";
import ResponsavelFinanceiro from "./ResponsavelFinanceiro";
import ResponsavelLegal from "./ResponsavelLegal";
import DadosProcurador from "./DadosProcurador";
import DadosBancarios from "./DadosBancarios";
import Documentos from "./Documentos";
import ConfirmarDados from "./ConfirmarDados";
import MensagemErro from "../MensagemErro";
import { useLocation, useNavigate } from "react-router-dom";
import {
  atualizarClienteDetalhado,
  buscarCheckpoint,
  inserirCheckpoint,
} from "../../services/api-planejamento-tributario.service";
import { uploadArquivosCliente } from "../../services/api-upload.service";
import { CadastroContext } from "../../config/Context/CadastroContext";
import { Context } from "../../config/Context/AuthContext";
import Loading from "../Loading";

const CadastroDetalhadoCliente = () => {
  const { dados, setDados } = useContext(CadastroContext);
  const { setDadosPendentes } = useContext(Context);

  const initialDataForm = {
    dadosTitular: {
      cep: dados?.cep?.replace(/[.]/g, "") || "",
      bairro: dados?.bairro || "",
      logradouro: dados?.logradouro || "",
      cidade: dados?.cidade || "",
      estado: dados?.estado || "",
      pais: "Brasil",
      tipoDocumento: dados?.tipoDocumento,
      cpf: dados?.cpf?.replace(/[.-]/g, "") || "",
      cnpj: dados?.cnpj?.replace(/[./-]/g, "") || "",
      nome: dados?.nome || "",
      numero: dados?.numero || "",
      complemento: dados?.complemento || "",
      email: dados?.email || "",
      telefone: dados?.telefone || "",
      whatsapp: "",
      dtAbertura: dados?.dtAbertura || "",
      simplesDtOpcao: dados?.simplesDtOpcao || "",
      simplesDtExclusao: dados?.simplesDtExclusao || "",
    },
    responsavelEmpresa: {
      nome: "",
      profissao: "",
      tipoDocumento: "CNPJ",
      documento: "",
      cpf: "",
      ramo: "",
      email: "",
      oab: "",
      crc: "",
      telefone: "",
      whatsapp: "",
      estrangeiro: false,
      foiIndicado: false,
      indicadoPor: "",
    },
    responsavelFinanceiro: {
      nome: "",
      cpf: "",
      tipoDocumento: "CNPJ",
      documento: "",
      email: "",
      telefone: "",
      whatsapp: "",
    },
    responsavelLegal: {
      nome: "",
      cpf: "",
      tipoDocumento: "CNPJ",
      documento: "",
      email: "",
      telefone: "",
      whatsapp: "",
    },
    dadosProcurador: {
      nome: "",
      cpf: "",
      tipoDocumento: "CNPJ",
      documento: "",
      email: "",
      telefone: "",
      whatsapp: "",
    },
    dadosBancarios: {
      banco: null,
      agencia: "",
      conta: "",
      pix: "",
    },
  };

  const mensagemErro = "Campo obrigatório";
  const minDesktop = useMediaQuery("(max-width: 770px)");
  const [activeStep, setActiveStep] = useState(0);
  const [hasReachedLastStep, setHasReachedLastStep] = useState(false);
  const [dataForm, setDataForm] = useState(initialDataForm);
  const [msg, setMsg] = useState("");
  const [openSnackbarErro, setOpenSnackbarErro] = useState(false);
  const [title, setTitle] = useState("");
  const [error, setError] = useState(false);
  const [files, setFiles] = useState({});
  const [cidade, setCidade] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const handleInitialData = async () => {
      try {
        const initialData = await buscarCheckpoint();
        if (initialData.checkpoint) {
          setDataForm(initialData.checkpoint.campos_preenchidos);
          setActiveStep(initialData.checkpoint.step);
        } else {
          const updatedDadosTitular = { ...dataForm.dadosTitular };
          for (const key in dados.dadosTitular) {
            if (
              dados.dadosTitular[key] !== null &&
              dados.dadosTitular[key] !== "" &&
              dados.dadosTitular[key] !== undefined
            ) {
              updatedDadosTitular[key] = dados.dadosTitular[key];
            }
          }
          setDataForm({
            ...dataForm,
            dadosTitular: updatedDadosTitular,
          });
        }
      } catch (error) {
        console.log(error);
      }
    };

    handleInitialData();
  }, []);

  useEffect(() => {
    if (activeStep !== 7) {
      setDadosPendentes({
        camposPreenchidos: dataForm,
        step: activeStep,
      });
      const handleBeforeUnload = (event) => {
        inserirCheckpoint({
          camposPreenchidos: dataForm,
          step: activeStep,
        });
        const message = "Tem certeza que deseja sair?";
        event.returnValue = message;
        return message;
      };

      window.addEventListener("beforeunload", handleBeforeUnload);

      return () => {
        window.removeEventListener("beforeunload", handleBeforeUnload);
      };
    }
  }, [dataForm, activeStep]);

  const styleMobileStepper = {
    display: "flex",
    justifyContent: "center",
    "& .MuiMobileStepper-progress": {
      width: "80vw",
      height: "1.5rem",
      backgroundColor: "transparent",
      border: "1px solid #18316e",
      borderRadius: "5px",
    },
    "& .MuiLinearProgress-barColorPrimary": {
      backgroundColor: "#18316e",
    },
  };

  const steps = [
    `Dados ${title}`,
    "Responsável pela Empresa",
    "Responsável Financeiro",
    "Responsável Legal",
    "Dados do Procurador",
    "Dados Bancários",
    "Anexo de documentos",
    "Confirmar Dados",
  ];

  const componentsNames = [
    DadosTitular,
    ResponsavelEmpresa,
    ResponsavelFinanceiro,
    ResponsavelLegal,
    DadosProcurador,
    DadosBancarios,
    Documentos,
    ConfirmarDados,
  ];

  const renderStepContent = (step) => {
    const StepComponent = componentsNames[step];
    return (
      <StepComponent
        component={StepComponent}
        activeStep={activeStep}
        handleStep={handleStep}
        dataForm={dataForm}
        setDataForm={setDataForm}
        setMsg={setMsg}
        setOpenSnackbarErro={setOpenSnackbarErro}
        error={error}
        setError={setError}
        handleError={handleError}
        handleHelperText={handleHelperText}
        title={title}
        files={files}
        setFiles={setFiles}
        handleSubmit={handleSubmit}
        setHasReachedLastStep={setHasReachedLastStep}
        cidade={cidade}
        setCidade={setCidade}
      />
    );
  };

  const handleCloseSnackbarErro = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnackbarErro(false);
  };

  const handleStep = (step) => {
    setActiveStep(step);
  };

  const handleError = (step, campo) => {
    if (error && !dataForm[step][campo]) {
      return true;
    } else {
      return false;
    }
  };

  const handleHelperText = (step, campo) => {
    if (error && !dataForm[step][campo]) {
      return mensagemErro;
    } else {
      return "";
    }
  };

  const handleSubmit = async () => {
    setLoading(true);
    try {
      const fileFormData = new FormData();

      Object.keys(files).forEach((key) => {
        fileFormData.append("files", files[key]);
        fileFormData.append("fileNames", key);
      });

      const { dadosTitular, ...rest } = dataForm;
      const newDataForm = { ...rest, dadosCliente: dadosTitular };

      await uploadArquivosCliente(dadosTitular.id, fileFormData);
      await atualizarClienteDetalhado(dadosTitular.id, {
        cliente: newDataForm,
      });

      navigate(`/proposta-em-analise`);
      setDadosPendentes();
    } catch (error) {
      setMsg("Erro ao atualizar cliente. Tente novamente.");
      console.error("Error ~~>:", error);
      setOpenSnackbarErro(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {loading ? (
        <Loading loading={loading} />
      ) : (
        <>
          <ResponsivContent>
            {minDesktop ? (
              <>
                <div className={styles.stepper__active}>
                  <span>{steps[activeStep]}</span>
                </div>

                <div className={styles.stepper__container}>
                  <MobileStepper
                    variant="progress"
                    activeStep={activeStep}
                    steps={steps.length}
                    position="static"
                    fullWidth
                    sx={styleMobileStepper}
                  />
                  <span
                    className={styles.stepper__label}
                    style={{
                      color: activeStep >= 4 ? "#fff" : "#18316e",
                      textShadow:
                        activeStep >= 3
                          ? " 0.5px 1px 0.7px rgba(0, 0, 0, 1)"
                          : "none",
                    }}
                  >{`${activeStep + 1}/${steps.length}`}</span>
                </div>
              </>
            ) : (
              <>
                <Stepper
                  nonLinear={hasReachedLastStep}
                  activeStep={activeStep}
                  alternativeLabel
                  sx={{ marginBlock: "2rem" }}
                >
                  {steps.map((label, index) => (
                    <Step key={label}>
                      <StepButton
                        icon={
                          !hasReachedLastStep ? (
                            activeStep >= index ? (
                              <StepIconCustom color={"#0f2047"}>
                                {steps.indexOf(label) + 1}
                              </StepIconCustom>
                            ) : (
                              <StepIconCustom color={"lightgray"}>
                                {steps.indexOf(label) + 1}
                              </StepIconCustom>
                            )
                          ) : activeStep === index ? (
                            <StepIconCustom color={"#4b6fc0"}>
                              <CheckIcon sx={{ fontSize: "1rem" }} />
                            </StepIconCustom>
                          ) : (
                            <StepIconCustom color={"#0f2047"}>
                              <CheckIcon sx={{ fontSize: "1rem" }} />
                            </StepIconCustom>
                          )
                        }
                        onClick={() => handleStep(index)}
                      >
                        <Typography variant="body1" sx={{ display: "block" }}>
                          {label}
                        </Typography>
                      </StepButton>
                    </Step>
                  ))}
                </Stepper>
              </>
            )}

            {renderStepContent(activeStep)}
          </ResponsivContent>
          <MensagemErro
            open={openSnackbarErro}
            handleClose={handleCloseSnackbarErro}
            msg={msg}
          />
        </>
      )}
    </>
  );
};

export default CadastroDetalhadoCliente;
